<template>
	<component :is="this.$route.meta.layout">
		<router-view />
	</component>
</template>
